module.exports = __webpack_public_path__ + "img/day8.3ddb1fd1.jpeg";